import { render } from "./ReservationSummary.vue?vue&type=template&id=595baf3c&scoped=true"
import script from "./ReservationSummary.vue?vue&type=script&lang=js"
export * from "./ReservationSummary.vue?vue&type=script&lang=js"

import "./ReservationSummary.vue?vue&type=style&index=0&id=595baf3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595baf3c"]])

export default __exports__